import { render, staticRenderFns } from "./ExpenseMenu.vue?vue&type=template&id=71246cfc&scoped=true"
import script from "./ExpenseMenu.vue?vue&type=script&lang=js"
export * from "./ExpenseMenu.vue?vue&type=script&lang=js"
import style0 from "./ExpenseMenu.vue?vue&type=style&index=0&id=71246cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71246cfc",
  null
  
)

export default component.exports